// Words on the glass, in three roles, in the page's monospace face: a line
// (14/20, the light text), a note (12/16, muted), and a label (11/16,
// uppercase, muted) over a group. The warn, good and bad voices are notes in
// their colour. Every one starts on the glass's left margin. The game's
// pixel type is for the display moments only (the code, the name, the big
// numbers), through pixelText.

export type Voice = 'line' | 'note' | 'label' | 'warn' | 'good' | 'bad';

export function say(text: string, voice: Voice = 'line', className = ''): HTMLElement {
  const node = document.createElement('p');
  node.className = `say say-${voice} ${className}`.trim();
  node.textContent = text;
  return node;
}
